export const content = {
    domain: "eMoneyUSA",
    footer: "emonyeusa.com",
    title1: "Get loan that works for you.",
  };
  